import { render, staticRenderFns } from "./CreateInventory.vue?vue&type=template&id=1ab2ded7"
import script from "./CreateInventory.vue?vue&type=script&lang=js"
export * from "./CreateInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports